import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import {
  DataCollectionApi,
  LivingSituationRequest,
} from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const submitLivingSituation = createAsyncThunk<
  LivingSituationRequest,
  LivingSituationRequest,
  ThunkApi
>("submitLivingSituation", async (args, { rejectWithValue }) => {
  try {
    await new DataCollectionApi().addLivingSituation(args);
    return args;
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Salvataggio situazione abitativa",
      description:
        "Non siamo riusciti a salvare la situazione abitativa.\n Puoi riprovare o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
